import { DataAction, Payload, StateRepository } from '@angular-ru/ngxs/decorators';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { createSelector, Selector, State, StateToken, Store } from '@ngxs/store';
import { produce } from 'immer';
import { ConfirmationService } from 'primeng/api';
import { combineLatest, Observable, of } from 'rxjs';
import { filter, first, map } from 'rxjs/operators';
import {
    CaseViewModel,
    IProductCategoryContext,
    IProductContextAssessmentStatus,
    IProductContextCase,
    IProductContextCaseStatus,
    IProductContextMetadataOwner,
    IProductInterviewConfig,
    IProductSmartActionReference,
    IProductStage,
    ProductCategoryNames,
} from 'src/app/models/case';
import { ICommunityCategory, ICommunityReferral } from 'src/app/models/community';
import { INotification } from 'src/app/models/notifications';
import { Product } from 'src/app/models/product';
import { Role } from 'src/app/models/role';
import { SignalREvent } from 'src/app/models/signalr';
import { IInterviewConfig } from 'src/app/shared/interview-new/models/interview.models';
import { InterviewHandlerService } from 'src/app/shared/interview-new/services/interview-handler.service';
import { FeatureService } from 'src/app/shared/preview-feature/preview-feature.service';

import { BaseProductServiceMultiple } from '../-base-product.service-multiple';
import { AppStateModel } from '../../+redux/redux.models';
import { ISmartActionContext, ISmartActionMetadata, SmartActionContext, SmartActionContextItem } from '../../../models/smart-actions.models';
import { AuntBerthaService } from '../../aunt-bertha/aunt-bertha.service';
import { CaseService } from '../../case/case.service';
import { ConfigurationService } from '../../configuration/configuration.service';
import { interviewCommunityDataProviderToken } from '../../interview-providers/interview-data-provider.tokens';
import { MemberService } from '../../member/member.service';
import { ProductContextService } from '../../product-context/product-context.service';
import { UserService } from '../../user/user.service';
import { AlertService } from './../../alert.service';
import { CommunityInterviewData } from './community-interview-data';
import { CommunityProgramsEndpoint } from './community-programs-endpoint.service';
import { CommunityStateModel } from './community-programs.state.models';
import { TaskOrchestratorService } from 'src/app/services/task-orchestrator/task-orchestrator.service';
import { ProductSelectorExtentions } from '../-base-product.service';

export const COMMUNITYPROGRAMS_TOKEN_KEY = 'communityState';
export const COMMUNITYPROGRAMS_TOKEN_TOKEN = new StateToken<CommunityProgramsService>(COMMUNITYPROGRAMS_TOKEN_KEY);


@StateRepository()
@State<CommunityStateModel>({
    name: 'communityState',
    defaults: {

    }
})
@Injectable()
export class CommunityProgramsService extends BaseProductServiceMultiple<CommunityStateModel> {

    static get currentCategory() {
        return createSelector([this], (state: CommunityStateModel) => {
            return state.currentCategory;
        });
    }

    static get currentCaseId() {
        return createSelector([this], (state: CommunityStateModel) => {
            return state.currentCaseId;
        });
    }


    static get assistedCategories() {
        return createSelector([this], (state: CommunityStateModel) => {
            return state.assistedCategories;
        });
    }



    @Selector()
    static communityPrograms(state: CommunityStateModel) {
        return state.communityPrograms;
    }

    @Selector()
    static packageNameSelector(state: CommunityStateModel) {
        return state.productCategoryContext.metadata.packageName;
    }

    @Selector()
    static packageVersionSelector(state: CommunityStateModel) {
        return state.productCategoryContext.metadata.packageVersion;
    }



    get communityPrograms$(): Observable<string[]> {
        return this.store.select<string[]>(CommunityProgramsService.communityPrograms);
    }

    get communityProgramsSync(): string[] {
        return this.store.selectSnapshot<string[]>(CommunityProgramsService.communityPrograms);
    }

    get stateToken() {
        return COMMUNITYPROGRAMS_TOKEN_TOKEN;
    }



    // get customView$(): Observable<string> {
    //     return this.store.select<string>(CommunityProgramsService.currentCustomView);
    // }

    // get productCase$(): Observable<CaseViewModel> {
    //     return this.store.select<CaseViewModel>(CommunityProgramsService.productCase(this));
    // }

    // get status$(): Observable<IProductContextCaseStatus> {
    //     return this.store.select<IProductContextCaseStatus>(CommunityProgramsService.status);
    // }

    // get statusSync(): IProductContextCaseStatus {
    //     return this.store.selectSnapshot<IProductContextCaseStatus>(CommunityProgramsService.status);
    // }

    // get caseOwner$(): Observable<IProductContextMetadataOwner> {
    //     return this.store.select<IProductContextMetadataOwner>(CommunityProgramsService.owner);
    // }

    // get caseOwnerSync(): IProductContextMetadataOwner {
    //     return this.store.selectSnapshot<IProductContextMetadataOwner>(CommunityProgramsService.owner);
    // }

    // get sourceProduct$(): Observable<Product> {
    //     return this.store.select<Product>(CommunityProgramsService.sourceProduct);
    // }

    // get productCategoryContext$(): Observable<IProductCategoryContext> {
    //     return this.store.select<IProductCategoryContext>(CommunityProgramsService.productCategoryContext);
    // }

    // get productCategoryContextSync(): IProductCategoryContext {
    //     return this.store.selectSnapshot<IProductCategoryContext>(CommunityProgramsService.productCategoryContext);
    // }

    // get metadataSync(): any {
    //     return this.store.selectSnapshot<any>(CommunityProgramsService.metadata);
    // }
    // get metadata$(): Observable<any> {
    //     return this.store.select<any>(CommunityProgramsService.metadata);
    // }

    // get currentCaseSync(): IProductContextCase {
    //     return this.store.selectSnapshot<IProductContextCase>(CommunityProgramsService.currentCase);
    // }

    // get currentCase$(): Observable<IProductContextCase> {
    //     return this.store.select<IProductContextCase>(CommunityProgramsService.currentCase);
    // }

    // get cases$(): Observable<IProductContextCase[]> {
    //     return this.store.select<IProductContextCase[]>(CommunityProgramsService.cases);
    // }

    // get casesSync(): IProductContextCase[] {
    //     return this.store.selectSnapshot<IProductContextCase[]>(CommunityProgramsService.cases);
    // }


    // get caseStageSync(): IProductStage {
    //     return this.store.selectSnapshot<IProductStage>(CommunityProgramsService.caseStage);
    // }

    // get caseStage$(): Observable<IProductStage> {
    //     return this.store.select<IProductStage>(CommunityProgramsService.caseStage);
    // }

    // get notifications$(): Observable<INotification[]> {
    //     return this.store.select<INotification[]>(CommunityProgramsService.notifications);
    // }

    // get productInterviewsSync(): IProductInterviewConfig[] {
    //     return this.store.selectSnapshot<IProductInterviewConfig[]>(CommunityProgramsService.productInterviews);
    // }

    // get productInterviews$(): Observable<IProductInterviewConfig[]> {
    //     return this.store.select<IProductInterviewConfig[]>(CommunityProgramsService.productInterviews);
    // }



    // get caseAssessmentSync(): IProductContextAssessmentStatus {
    //     return this.store.selectSnapshot<IProductContextAssessmentStatus>(CommunityProgramsService.caseAssessment);
    // }
    // get caseAssessment$(): Observable<IProductContextAssessmentStatus> {
    //     return this.store.select<IProductContextAssessmentStatus>(CommunityProgramsService.caseAssessment);
    // }

    // get iconSync(): string {
    //     return this.store.selectSnapshot<string>(CommunityProgramsService.icon);
    // }
    // get icon$(): Observable<string> {
    //     return this.store.select<string>(CommunityProgramsService.icon);
    // }

    // get noCaseMessageSync(): string {
    //     return this.store.selectSnapshot<string>(CommunityProgramsService.noCaseMessage);
    // }
    // get noCaseMessage$(): Observable<string> {
    //     return this.store.select<string>(CommunityProgramsService.noCaseMessage);
    // }

    // get categoryDisplayNameSync(): string {
    //     return this.store.selectSnapshot<string>(CommunityProgramsService.categoryDisplayName);
    // }
    // get categoryDisplayName$(): Observable<string> {
    //     return this.store.select<string>(CommunityProgramsService.categoryDisplayName);
    // }

    // get stagesSync(): IProductStage[] {
    //     return this.store.selectSnapshot<IProductStage[]>(CommunityProgramsService.stages);
    // }
    // get stages$(): Observable<IProductStage[]> {
    //     return this.store.select<IProductStage[]>(CommunityProgramsService.stages);
    // }

    get categories$() {
        return this.store.select<any>(ProductSelectorExtentions.metadata(this)).pipe(map(_ => _ && _.categories as ICommunityCategory[]));
    }

    get categoriesSync() {
        const metadata = this.store.selectSnapshot<any>(ProductSelectorExtentions.metadata(this));
        return metadata && metadata.categories as ICommunityCategory[];
    }

    get currentCategorySync(): ICommunityCategory {
        return this.store.selectSnapshot<ICommunityCategory>(CommunityProgramsService.currentCategory);
    }
    get currentCategory$(): Observable<ICommunityCategory> {
        return this.store.select<ICommunityCategory>(CommunityProgramsService.currentCategory);
    }

    get currentCaseId$(): Observable<string> {
        return this.store.select<string>(CommunityProgramsService.currentCaseId);
    }

    get assistedCategoriesSync(): string[] {
        return this.store.selectSnapshot<string[]>(CommunityProgramsService.assistedCategories);
    }
    get assistedCategories$(): Observable<string[]> {
        return this.store.select<string[]>(CommunityProgramsService.assistedCategories);
    }


    get packageNameSync(): string[] {
        return this.store.selectSnapshot<string[]>(CommunityProgramsService.packageNameSelector);
    }
    get packageName$(): Observable<string[]> {
        return this.store.select<string[]>(CommunityProgramsService.packageNameSelector);
    }


    get packageVersionSync(): string[] {
        return this.store.selectSnapshot<string[]>(CommunityProgramsService.packageVersionSelector);
    }
    get packageVersion$(): Observable<string[]> {
        return this.store.select<string[]>(CommunityProgramsService.packageVersionSelector);
    }


    get smartActionsSync(): IProductSmartActionReference[] {
        return [];
    }
    private _smartActions = of([]);
    get smartActions$(): Observable<IProductSmartActionReference[]> {
        return this._smartActions;
    }


    get interviewDataProviderToken() {
        return interviewCommunityDataProviderToken;
    }

    get interviews() {
        return this.productInterviewsSync?.map(item => ({ ...item } as IInterviewConfig));
    }


    constructor(
        memberService: MemberService,
        userService: UserService,
        protected caseService: CaseService,
        productContextService: ProductContextService,
        confirmationService: ConfirmationService,
        private communityEndpoint: CommunityProgramsEndpoint,
        router: Router,
        route: ActivatedRoute,
        alertService: AlertService,
        store: Store,
        featureService: FeatureService,
        public auntBethaService: AuntBerthaService,
        taskOrchestratorService: TaskOrchestratorService
    ) {
        super(
            'Community',
            memberService,
            userService,
            caseService,
            productContextService,
            confirmationService,
            router,
            route,
            alertService,
            CommunityInterviewData,
            store,
            featureService,
            new InterviewHandlerService(),
            taskOrchestratorService
        );

    }

    matchingCaseFunc = (item: IProductContextCase, context: { [key: string]: any }) => {
        if (item.metadata?.referral && context) {
            const referral = item.metadata.referral as ICommunityReferral;
            return referral.category === context.caseIdentifier;
        }

        return false;
    }

    async ngxsAfterBootstrap() {

        super.ngxsAfterBootstrap();

        // Error: Not work form multiple member access in the same app load
        // Wait until authenticated to get access to access_token. UserService.userIdentifier need to be replaced by something more specific to access token.
        await combineLatest([this.store.select<string>(UserService.userIdentifier), this.store.select<boolean>(ConfigurationService.initializedSelector)]).pipe(filter(([userIdentifier, configInitialized]) => !!userIdentifier && configInitialized), first()).toPromise();
        combineLatest([this.store.select<string>((store: AppStateModel) => store.memberState.currentSession.base64)]).pipe(filter(([base64]) => !!base64)).subscribe(async ([base64]) => {
        });
    }


    signalRFilter(event: SignalREvent): boolean {
        return true;
    }

    wasAssisted(categoryName: string) {
        return (this.assistedCategoriesSync || []).findIndex(item => item === categoryName) >= 0;
    }


    protected getAllowedActions(productCaseNew: IProductContextCase, sourceProduct: Product, userRole?: Role): Observable<SmartActionContext> {
        return combineLatest([this.userService.currentRole$]).pipe(map(([userRole]) => {
            const actions: SmartActionContextItem[] = [];

            const allowedRoles = ['SCREENER', 'ADVOCATE'];
            if (userRole?.inRoles(allowedRoles)) {
                actions.push(new SmartActionContextItem({
                    id: `${ProductCategoryNames[this.productCategory]}-newcase`,
                    displayName: 'New Case',
                    disabled: true,
                    target: this,
                    handler: this,
                    description: 'Add new community program case.',
                    icon: 'fal fa-plus',
                    command: async (context: ISmartActionMetadata) => {
                    }
                } as SmartActionContextItem));
            }

            return new SmartActionContext({
                id: `${this.productCategory}-assistance`,
                displayName: 'Assistance',
                description: 'We\'re always here to Assist!',
                actions

            } as ISmartActionContext);
        }));
    }

    public getReferrals(tenantId: string, memberId: string): Observable<string[]> {
        return this.communityEndpoint.getReferrals(tenantId, memberId);
    }

    getProgramCase(category: ICommunityCategory) {
        return this.casesSync.find(_ => (_.metadata.referral as ICommunityReferral).category === category.name);
    }

    setCurrentReferralCase($case: IProductContextCase, category?: ICommunityCategory) {
        this.setCurrentCase($case);
        this.setCurrentCategory(category)
    }

    @DataAction()
    setCurrentCategory(@Payload('category') category: ICommunityCategory) {
        this.ctx.setState(produce(this.ctx.getState(), (draft: CommunityStateModel) => {
            draft.currentCategory = category;
        }));
    }

    @DataAction()
    setAssisted(@Payload('category') category: ICommunityCategory) {
        this.ctx.setState(produce(this.ctx.getState(), (draft: CommunityStateModel) => {
            if (draft.currentCategory) {
                const assistedCategories = [...(draft.assistedCategories || [])];
                const categoryIndex = assistedCategories.findIndex(item => item === draft.currentCategory.name);
                if (categoryIndex === -1) {
                    assistedCategories.push(draft.currentCategory.name)
                    draft.assistedCategories = assistedCategories;
                }
            }
        }));
    }

    @DataAction()
    async getCommunityReferrals(@Payload('base64') base64: string, safeState = false) {
        let result: string[];

        if (base64) {
            const segments = MemberService.parseBase64(base64);

            result = await this.getReferrals(segments.tenantId, segments.memberId).pipe(first()).toPromise();
        }

        if (safeState) {
            this.ctx.setState(produce(this.ctx.getState(), (draft: CommunityStateModel) => {
                draft.communityPrograms = result;
            }));
        }

        return result;
    }
}
